<template>
  <div
    @click="setSpotState(productData.Position, 'active')"
    @mouseenter="setSpotState(productData.Position)"
    class="product-details row"
    :class="{
      'not-applicable': productData.Product.NotApplicable,
      active,
      [`spot-${productData.Position}`]: true,
    }"
  >
    <div class="col-xs-12">
      <!-- <router-link
        class="link"
        :to="{ name: 'Level4Product', params: { product: productData.Product.Id }}"
      > -->
      <SfHeading
        class="sf-heading--left"
        :level="3"
        :description="productData.Product.Name"
        :title="productData.Product.Sku"
      />
      <!-- </router-link> -->
      <p class="m-tb-10 text-danger" v-if="productData.Product.NotApplicable">
        {{ $t("Not applicable to this vehicle.") }}
        {{ $t("Select or change vehicle.") }}
      </p>
      <p class="m-tb-10" v-if="productData.CommentBefore">
        {{ productData.CommentBefore }}
      </p>
    </div>
    <div class="col-xs-6">
      <div class="m-tb-10">
        <SfProperty
          v-if="productData.Position"
          class="m-b-5"
          :name="$t('Position')"
          :value="productData.Position"
        />
        <ProductAttributes :attributes="productData.Product.Attributes" />
      </div>
    </div>
    <div class="col-xs-6" v-if="isProductAvailable">
      <div class="m-tb-5">
        <SfProperty
          class="column-property old-price m-b-10"
          v-if="productStock.OldPrice"
          :name="$t('Gross Catalog Price')"
          :value="currencyFormatter().format(productStock.OldPrice)"
        />
        <SfProperty
          class="column-property old-price m-b-10"
          v-if="productStock.OldPriceNetto && showPriceNetto()"
          :name="$t('Net Catalog Price')"
          :value="currencyFormatter().format(productStock.OldPriceNetto)"
        />
        <SfProperty
          class="column-property price m-tb-10"
          v-if="productStock.Price"
          :name="$t('Gross Price')"
          :value="currencyFormatter().format(productStock.Price)"
        />
        <SfProperty
          class="column-property price m-tb-10"
          v-if="productStock.PriceNetto && showPriceNetto()"
          :name="$t('Net Price')"
          :value="currencyFormatter().format(productStock.PriceNetto)"
        />
        <SfProperty
          class="column-property discount m-tb-10"
          v-if="productStock.Discount"
          :name="$t('Discount')"
          :value="`${productStock.Discount}%`"
        />
      </div>
    </div>
    <div class="col-xs-6" v-if="isProductAvailable">
      <div v-if="productStock.WarehouseInventory && productStock.WarehouseInventory.length">
        <SfProperty class="m-b-5" :name="$t('Stock')" />
        <SfProperty
          v-for="stock in productStock.WarehouseInventory"
          :key="stock.WarehouseId"
          :name="warehouseName(stock.WarehouseId)"
          :value="stock.StockQuantity"
        />
      </div>
    </div>
    <div class="col-xs-6" v-if="!productData.Product.NotApplicable">
      <SfQuantitySelector class="f-right" v-model="qty" aria-label="Quantity" />
    </div>
    <div class="m-tb-10 col-xs-12" v-if="!productData.Product.NotApplicable">
      <SfButton v-if="isProductAvailable" class="f-right" @click="addToCart">
        {{ $t("Add to cart") }}
      </SfButton>
      <SfButton
        v-else
        class="f-right"
        :disabled="isLoading"
        @click="getStockAndPrice(productData.Product.Sku)"
      >
        {{ isLoading ? $t("Loading") : $t("Check Stock and Price") }}
      </SfButton>
    </div>
    <div class="col-xs-12" v-if="stockChecked && !isProductAvailable">
      <p class="text-danger error-info">{{ $t("Product temporarily unavailable.") }}</p>
    </div>
    <div class="col-xs-12">
      <p v-if="productData.CommentAfter" class="comment-affter">
        {{ productData.CommentAfter }}
      </p>
      <SfAccordion transition="sf-expand" class="m-tb-10">
        <SfAccordionItem
          v-for="accordion in accordions"
          :key="accordion.header"
          :header="accordion.header"
        >
          <p class="m-b-5" v-for="info in accordion.list" :key="info.Sku">
            <SfHeading
              class="m-tb-15 sf-heading--left"
              :level="4"
              :title="info.Name"
              :description="info.Sku"
            />
            <ProductAttributes class="accordian-attributes" :attributes="info.Attributes" />
          </p>
        </SfAccordionItem>
      </SfAccordion>
    </div>
  </div>
</template>

<script>
import {
  SfHeading,
  SfQuantitySelector,
  SfButton,
  SfProperty,
  SfAccordion,
} from '@storefront-ui/vue';
import _ from 'lodash';
import { mapActions } from 'vuex';
import { config } from '@/modules/core';
import cart from '@/modules/checkout/mixins/cart';
import ProductAttributes from './ProductAttributes.vue';
import hotspots from '../../mixins/hotspots';

const availabilityPrice = 0;

export default {
  name: 'ProductDetails',
  mixins: [config, cart, hotspots],
  components: {
    SfHeading,
    SfQuantitySelector,
    SfButton,
    SfProperty,
    SfAccordion,
    ProductAttributes,
  },
  props: {
    isSimple: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  watch: {
    hotspots(newSpots) {
      const activeSpot = _.find(newSpots, { active: true }) || {};
      this.active = activeSpot.bildposNummer === parseInt(this.productData.Position, 10);
    },
  },
  data() {
    return {
      active: false,
      stockChecked: this.isSimple,
      isLoading: false,
      productData: this.product,
      productStock: this.product?.Product,
      qty: this.product?.Product?.Attributes?.Quantity
        ? this.product.Product.Attributes.Quantity[0]
        : 1,
    };
  },
  computed: {
    isProductAvailable() {
      return (
        this.stockChecked && this.productStock?.Price && this.productStock.Price > availabilityPrice
      );
    },
    accordions() {
      return [
        ...(() => (this.productData.ProductBundleList?.length
          ? [
            {
              header: this.$t('Bundled with products'),
              list: this.productData.ProductBundleList,
            },
          ]
          : []))(),
        ...(() => (this.productData.ProductRepairList?.length
          ? [
            {
              header: this.$t('Products necessary for repair'),
              list: this.productData.ProductRepairList,
            },
          ]
          : []))(),
        ...(() => (this.productData.ProductFitList?.length
          ? [
            {
              header: this.$t('Fits to products'),
              list: this.productData.ProductFitList,
            },
          ]
          : []))(),
      ];
    },
  },
  methods: {
    addToCart() {
      const data = {
        ProductId: this.productData.Product.Id,
        Quantity: this.qty || 1,
      };
      this.addItemAndOpenCart(data);
    },
    getStockAndPrice(sku) {
      this.isLoading = true;
      this.fetchStock(sku)
        .then((productStock) => {
          this.productStock = productStock;
          this.stockChecked = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showPriceNetto() {
      return !!this.storeConfig?.general?.showPriceNetto;
    },
    ...mapActions({
      fetchStock: 'level4/fetchStock',
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint.scss";

.link {
  text-decoration: none;
}

.f-right {
  float: right;
}

.sf-accordion-item {
  --accordion-item-header-color: var(--c-primary);
}

.accordian-attributes {
  padding-left: 10px;
  border-left: 2px solid var(--c-light);
}

.not-applicable {
  opacity: 0.8;
}

.column-property {
  flex-direction: column;
  --property-value-font-size: 20px;
}

.old-price {
  --property-value-color: var(--c-danger);
  /deep/ .sf-property__value {
    text-decoration: line-through;
  }
}

.price,
.discount {
  --property-value-color: var(--c-primary);
}

.error-info {
  text-align: right;
}
</style>
